'use strict';
import React, { PureComponent } from 'react';

//
import { GenericErrorScreen, GenericModal, GenericAlert, GenericBreadcrumb } from 'com-gyf-webcore-userinterfacecomponents';
import ClienteTitle from '../../../Common/Components/ClienteTitle.jsx';
import Elementos from './Elementos.jsx';
import Labels from './Labels.jsx';
import SubTitulo from './SubTitulo.jsx';
import Footer from './Footer.jsx';
import CheckBoxImprimir from './CheckBoxImprimir.jsx';
import AlertaInconsistencias from './AlertaInconsistencias.jsx';
import AvisoFinal from './AvisoFinal.jsx';
import RequestedCardsTable from './RequestedCardsTable.jsx';
import ModifiedLimitsTable from './ModifiedLimitsTable/Table.jsx';
import ProcessManager from '../../../Common/Managers/ProcessManager.js';
import { Redirect } from 'react-router-dom';

// Funciones helpers.
import { getAccountModifiedLimits, getEnterpriseModifiedLimits } from './helpers.jsx';

import {
    GET_SCREEN_DATA,
    GET_SCREEN_DATA_RESULT,
    ROUTE_TO_NEXT,
    ROUTE_TO_PREVIOUS,
    ROUTE_TO_CANCEL,
    ROUTE_TO_ADMINISTRADORA,
    ROUTE_TO_TARJETAS,
    ROUTE_TO_TIPO_EMPRESA,
    ROUTE_TO_EMPRESA,
    ROUTE_TO_CUENTA,
    ROUTE_TO_PRODUCTO,
    ROUTE_TO_CONFIRMACION,
    SAVE_REQUEST,
    FINISH_REQUEST,
    SHOW_SAVE_STATUS,
    STOP_SPINNER,
    FUNCTION_CODE_CREATE,
    FUNCTION_CODE_QUERY,
    FUNCTION_CODE_DISTRIBUTION
} from '../actions/NuevaSolicitudConfirmacionActions.js';

class NuevaSolicitudConfirmacion extends PureComponent {

    componentDidMount() {
        this.props.GetScreenData(this.props.state, this.props.currentScope, this.props.tarjetas, this.props.sesion);
    }

    componentWillUnmount() {
        this.props.resetStateSolicitudConfirmacion();
    }

    cancelRequest() {
        this.props.routeToCancel(this.props.data.routtingState.request);
    }

    render() {
        if (this.props.data.loaded) {

            if (this.props.data.redirectToVistaCliente == true)
                return <Redirect to={ProcessManager.GetNextStep("NuevaSolicitudConfirmacion", "ROUTE_TO_VISTA_CLIENTE")} push />;

            const permissions = this.props.data.permissions;
            const {
             enterpriseLimit,
                enterpriseLimitCopy,
                accountLimit,
                accountLimitCopy,
                creditCards,
                administrator
          } = this.props.data;

            // TODO: los ámbitos de las tarjetas de credito estan bien
            //const { denomination } = this.state.data.enterprise;
            //const { description } = this.state.data.account;

            const { denomination } = this.props.data.enterprise;
            const { description } = this.props.data.account;

            // Obtener limites modificados.
            const enterpriseModified = getEnterpriseModifiedLimits(enterpriseLimit, enterpriseLimitCopy, administrator, denomination);

            let accountModified = [];
            if (accountLimit !== undefined && accountLimit.length > 0 && accountLimitCopy !== undefined && accountLimitCopy.length > 0 && description !== undefined) {
                accountModified = getAccountModifiedLimits(accountLimit, accountLimitCopy, administrator, description);
            }

            const modifiedLimits = enterpriseModified.concat(accountModified);

            let routtingState = { request: this.props.data.routingState };
            let genericAlert = this.props.data.showError ? <GenericAlert message="Por favor recuerde que debe seleccionar una empresa, ya que es parte de la solicitud." type="danger" /> : null;
            let cuentaTarjetaId = this.props.data.account.find(x => x.seleccionada).CuentaTarjetaId;
            let tarjetasSolicitud = this.props.data.creditCard.filter(x => x.CuentaTarjetaId == cuentaTarjetaId && x.TieneBaja != "1" || x.Id <= 0);

            if (permissions.components.Pantalla.Active == true) {
                return (
                    <div className="container-fluid">
                        <ClienteTitle
                            novedadesEmpresas={this.props.tarjetas.novedadesEmpresas}
                            empresas={this.props.tarjetas.empresas}
                            titulo={(this.props.tarjetas.esModificacion == true ? "Solicitud para " : "Nueva solicitud para ") + this.props.data.client.description}
                            cliente={this.props.data.client} /*empresas={routtingState.GET_EMPRESA_CUIT}*/ />
                        <br />

                        <GenericBreadcrumb
                            className="breadcrumb"
                            currentScreen={this.props.currentScreen}
                            menu={this.breadcrumbGenerator()}
                            state={this.props.data.routingState}
                            product={this.props.currentScope.ProductCode}
                            module={this.props.currentScope.CategoryCode}
                        />

                        <br />
                        <Labels
                            administrator={this.props.data.administrator}
                            kindEnterprise={this.props.data.kindEnterprise}
                            enterprise={this.props.data.enterprise}
                            account={this.props.data.account}
                        />
                        <br />
                        <SubTitulo subtitulo="Tarjetas a solicitar" />
                        <div className="row">
                            <div className="col-md-12"><hr className="separator-line separator-light" /></div>
                        </div>
                        <RequestedCardsTable creditCards={tarjetasSolicitud} />

                        <ModifiedLimitsTable modifiedLimits={modifiedLimits} />

                        <br />
                        {this.props.data.limitDistributionSuccess ? <CheckBoxImprimir /> : <AlertaInconsistencias />}
                        <br />
                        <Footer
                            limitDistributionSuccess={this.props.data.limitDistributionSuccess}
                            routingPrevious={this.props.routingPrevious}
                            request={this.props.data.routtingState.request}
                            readyRequest={this.props.data.readyRequest}
                            guardarSolicitud={this.props.guardarSolicitud}
                            permissions={permissions}
                            limiteExedido={this.props.data.limiteExedido}
                        />
                        <GenericModal
                            type={"DISCARD_CHANGES_CANCEL"}
                            className="modal fade-out"
                            onClick={() => this.cancelRequest(this.props.data.routtingState.request)}
                            id={"discardChangesModal"}
                            header={"Descartar cambios"}
                            body={"Usted tiene cambios sin guardar ¿Quiere descartarlos y volver a la pantalla inicial?"}
                        />
                        <GenericModal
                            type={"WITH_COMPONENTS"}
                            className="modal fade-out"
                            id={"endRequestAdvice"}
                            component={<AvisoFinal routeToPrevious={this.props.data.routeToPrevious} />} size={"modal-lg"}
                        />
                        <GenericModal type={"OK_OTHER"} className="modal fade-out" id={"error"}
                            header={"La solicitud no puede ser procesada"}
                            body={"Por favor comuniquese con Soporte técnico para recibir asistencia y solucionarlo lo antes posible. Su número de transacción es " + this.props.data.sagaId}
                            onClick={() => this.props.finalizarSolicitud()} />
                        <GenericModal type={"OK_OTHER"} className="modal fade-out" id={"completada"}
                            body={"La transacción ha sido creada exitosamente"}
                            onClick={() => this.props.finalizarSolicitud()} />
                        <GenericModal type={"OK_OTHER"} className="modal fade-out" id={"completadaConDependencias"}
                            header={"La solicitud esta pendiente a ser procesada"}
                            body={"Disculpe, hay datos en la solicitud que dependen de procesos que todavían no fueron finalizados, por lo que aun no se encuentra confirmada.\nUsted no debe hacer nada: Una vez que los procesos de los que dependen esta solicitud hayan finalizado correctamente será avisado y la solicitud avanzará automáticamente por su circuito normal."}
                            onClick={() => this.props.finalizarSolicitud()} />
                    </div>
                );

            }
            else {
                if (permissions.components.Pantalla.Active == false) {
                    let values = {
                        message: "Disculpe, no tiene permisos para acceder a esta pantalla.",
                        linkMessage: "Volver a mi pagina de inicio"
                    };

                    return <GenericErrorScreen data={values} />;
                }
            }
        }
        else
            return null;

    }

    breadcrumbGenerator() {
        let nuevaSolicitudMap = [];
        nuevaSolicitudMap.push({
            descripcion: this.props.data.routtingState.request.tarjetas.administradora.Descripcion,
            ruta: ProcessManager.GetNextStep("NuevaSolicitudConfirmacion", "ROUTE_TO_ADMINISTRADORA"),
            activo: false,
            normal: false
        });

        nuevaSolicitudMap.push({
            descripcion: this.props.data.routtingState.request.tarjetas.tipoEmpresa.find(x => x.seleccionada == true).Descripcion,
            ruta: ProcessManager.GetNextStep("NuevaSolicitudConfirmacion", "ROUTE_TO_TIPO_EMPRESA"),
            activo: false,
            normal: false
        });

        nuevaSolicitudMap.push({
            descripcion: this.props.data.routtingState.request.tarjetas.empresas.find(x => x.seleccionada == true).Descripcion,
            ruta: ProcessManager.GetNextStep("NuevaSolicitudConfirmacion", "ROUTE_TO_EMPRESA"),
            activo: false,
            normal: false
        });

        nuevaSolicitudMap.push({
            descripcion: this.props.data.routtingState.request.tarjetas.cuentas.find(x => x.seleccionada == true).Descripcion,
            ruta: ProcessManager.GetNextStep("NuevaSolicitudConfirmacion", "ROUTE_TO_CUENTA"),
            activo: false,
            normal: false
        });

        nuevaSolicitudMap.push({
            descripcion: "Tarjetas",
            ruta: ProcessManager.GetNextStep("NuevaSolicitudConfirmacion", "ROUTE_TO_TARJETA"),
            activo: false,
            normal: false
        });

        nuevaSolicitudMap.push({
            descripcion: "Confirmación",
            ruta: "",
            activo: true,
            normal: true
        });

        return nuevaSolicitudMap;
    }

}

export default NuevaSolicitudConfirmacion;